export const eventType = {
  SERVICE_VISIT: 'Service Visit'
}
export const dashboardTypes = {
  CUSTOMER_TECH: 'Customer Tech'
}
